export const layout = {
  layout_navTab_invite: 'Invitar',
  layout_navTab_calendar: 'Calendario',
  layout_navTab_questionnaires: 'Cuestionarios',
  layout_navTab_profile: 'Perfil',
  layout_navTab_study: 'Estudio',
};
